import { Alert, Button, TextField } from "@mui/material";
import { useAsyncAction } from "nate-react-api-helpers";
import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../api/API";
import { useUrlState } from "../../misc/urlParams";
import { AccountCard } from "./AccountCard";

export function ResetPasswordPage() {
    const url = useUrlState();
    const token = url.text("token");

    const [password, setPassword] = useState("");
    const [again, setAgain] = useState("");
    const [done, setDone] = useState(false);

    const reset = useAsyncAction(async (input: { token: string; password: string }) => {
        await api.account.resetPassword(input);
        setDone(true);
    }, []);

    const mismatch = !!again && password !== again;

    return (
        <AccountCard title="Pick a new password">
            {done ? (
                <>
                    <Alert severity="success">Your password is set.</Alert>
                    <Button component={Link} to="/login" variant="contained" fullWidth sx={{ mt: 2 }}>
                        Log in
                    </Button>
                </>
            ) : (
                <form onSubmit={e => {
                    e.preventDefault();
                    reset.callback({ token: token, password: password });
                }}>
                    <TextField label="New password" type="password" autoComplete="new-password" fullWidth
                               helperText="At least 8 characters"
                               value={password} onChange={e => setPassword(e.target.value)} />
                    <div style={{ height: 8 }} />
                    <TextField label="New password again" type="password" autoComplete="new-password" fullWidth
                               error={mismatch} helperText={mismatch ? "The passwords are not the same" : " "}
                               value={again} onChange={e => setAgain(e.target.value)} />
                    <div style={{ height: 8 }} />
                    <Button type="submit" variant="contained" fullWidth
                            disabled={reset.loading || !password || password !== again}>
                        Set password
                    </Button>
                    {reset.LoadingElement}
                </form>
            )}
        </AccountCard>
    );
}
